'use strict';

module Patersons {

    export class CapitalTransactionStatement extends AbstractReport {
        tradeCategories: TradeCategory[];
    }

    export class TradeCategory {
        name: string;
        transactions: CapitalTransaction[];
        subtotal: CapitalTransaction;
    }

    export class CapitalTransaction {
        tradeDate: Date;
        settlementDate: Date;
        quantity: number;
        code: string;
        description: string;
        unitPrice: number;
        grossAmount: number;
        brokerage: number;
        gst: number;
        netAmount: number;
        tradeCategory: string;
    }

    export class CapitalTransactionStatementComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/capitalTransactionStatement.component.html';
        controller: any = CapitalTransactionStatementController;
        bindings: any = {
            report: '<',
            title: '@'
        };
    }

    export class CapitalTransactionStatementController extends AbstractReportController {
        report: CapitalTransactionStatement;
    }

}

